export default {"src":"/_next/static/media/hotline24_40.78866dbb.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};